<template>
  <div class="tabs-container ng-scope" style="padding-bottom:50px;margin-top:18px;">
    <form method="get" class="form-horizontal" id="baseInfo" novalidate="novalidate">
      <div class="tab-content">
        <div>
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.userName") }}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <div>
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="user.userName"
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      :name="'Username'"
                      maxLength="30"
                      autocomplete="off"
                    />
                  </div>
                  <label class="error">{{ errors.first('Username') }}</label>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.password") }}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <div>
                    <input
                      type="password"
                      class="form-control"
                      v-model.trim="user.password"
                      v-validate="'required|min:6'"
                      data-vv-validate-on="blur"
                      :name="'Password'"
                      autocomplete="off"
                    />
                  </div>
                  <label class="error">{{ errors.first('Password') }}</label>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.email") }}
                </label>
                <div class="col-sm-10">
                  <div>
                    <input
                      type="email"
                      class="form-control"
                      v-model.trim="user.email"
                      :name="'email'"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.RoleName") }} 
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-3">
                  <div>
                    <select class="form-control" v-validate="'required'" v-model="user.roleId" name="role">
                      <option  value="">{{$t("message.PleaseSelect") }}</option>
                      <option  class="ng-binding" v-for="role in roleList" v-bind:value="role.id">{{role.roleName}}</option>
                    </select>
                  </div>
                  <label class="error">{{ errors.first('role') }}</label>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.Status") }} 
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-3">
                  <div>
                    <select class="form-control" v-model="user.status" name="status" v-validate="'required'">
                      <option  value="">{{$t("message.PleaseSelect") }}</option>
                      <option value="1" class="ng-binding">{{$t("message.Active") }} </option>
                      <option value="0" class="ng-binding">{{$t("message.Inactive") }}</option>
                    </select>
                  <label class="error">{{ errors.first('status') }}</label>
                  </div>
                </div>
              </div>

              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <div class="btn btn-primary" @click="submit()">{{$t("message.Save") }}</div>
                    <div class="btn btn-white" @click="showWarning()">{{$t("message.Cancel") }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import eventBus from "../eventbus";
import config from "../config";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      user: {},
      roleList:[]
    };
  },
  created() {
    this.init();
  },
  mounted() {
  },
  methods: {
    async init() {
      let id = this.$route.query.id;
      if (id) {
        let obj = this.getAuthObj;
        obj.systemUserId = id;
        let data = await this.$store.dispatch("detailUserList", this.setFormData(obj));
        data.data.result.updUserId = data.data.result.id;
        data.data.result.roleId = data.data.result.systemRoleId;
        this.$set(this, "user", data.data.result);
      } else {
        let initUser = {
          id: null,
          password: "",
          userName: "",
          email: "",
          mobile: "",
          status: "",
          roleId: "",
        };
        this.$set(this, "user", initUser);
      }
      this.getRoleList();
    },
    async getRoleList(){
        let obj = this.getAuthObj;
        let data = await this.$store.dispatch("getSystemRoleAllList", this.setFormData(obj));
        this.$set(this, "roleList", data.data.result);
    },
    showWarning(type) {
      var that =this;
      if (!type) {
        that.$router.go(-1);
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [{
              name:this.$i18n.t("message.Confirm"),
              callBack:function(){
                that.callDelete();
              }
            },{
              name:this.$i18n.t("message.Cancel"),
              callBack:function(){
                    that.$store.commit("setwarning", {
                      string: "",
                      boolean: false,
                    });
              }
            }]
        });
      }
    },
    async submit() {
      try {

        let vresult = await this.$validator.validate();
        if (!vresult) {
          this.fillInRequired();
          return;
        }

        let obj = this.getAuthObj;
        for(var key in this.user){
          obj[key] = this.user[key];
        }
  
        if(this.$route.query.id){
           var  data = await this.$store.dispatch("updateSystemUser", this.setFormData(obj));
        }else{
           var  data = await this.$store.dispatch("createSystemUser", this.setFormData(obj));
        }
        
        if (data.data.errorCode === 0) {
          this.$router.go(-1);
        }
      } catch (err) {
        console.error(err);
      }
    },
    Delete() {
      this.showWarning(1);
    },
    async callDelete() {
      try {
        let obj = this.getAuthObj;
        obj.ids = [this.$route.query.id];
        let data = await this.$store.dispatch("deleteUserList", this.setFormData(obj));
        if (data.data.errorCode === 0) {
          this.$router.go(-1);
        }
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>
